export default [
    {
        path: '/cluster/list',
        name: 'cluster_list',
        component: () => import('@src/cluster/cluster-list.vue'),
        meta: {
            title: 'Cluster verwalten',
            role: 'ROLE_CLUSTER_MANAGEMENT',
        },
    },
    {
        path: '/cluster/create',
        name: 'cluster_create',
        component: () => import('@src/cluster/cluster-create.vue'),
        meta: {
            title: 'Cluster anlegen',
            role: 'ROLE_CLUSTER_MANAGEMENT',
        },
    },
    {
        path: '/cluster/edit/:id',
        name: 'cluster_edit',
        component: () => import('@src/cluster/cluster-edit.vue'),
        props(route: any) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
        meta: {
            title: 'Cluster bearbeiten',
            role: 'ROLE_CLUSTER_MANAGEMENT',
        },
    },
];
